/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {exchangeSessionTokenInternal} from '../api'

export const useMutationExchangeSessionTokenInternal = createReactQueryMutationHook('exchangeSessionTokenInternal', exchangeSessionTokenInternal)
